import { createAction } from 'typesafe-actions';

import { Underground } from 'shared/types/filters/geo';

export const removeUndergroundStations = createAction('filters/removeUndergroundStations')<Underground['id'][]>();
